import { LoaderFunction, useLoaderData } from "remix";
import { BreadcrumbLink } from "~/components/Breadcrumbs";
import { ContentBlock } from "~/components/ContentBlock";
import { ContentBlockModel, getContentBlock } from "~/utils/contentBlocks";
import { getUserId } from "~/utils/session.server";

interface LoaderData {
  title: ContentBlockModel;
  content: ContentBlockModel;
  image: ContentBlockModel;
  editable: boolean;
}

export const handle = {
  breadcrumb: () => <BreadcrumbLink to="/about">About</BreadcrumbLink>,
};

export const loader: LoaderFunction = async ({ request }) => {
  const title = await getContentBlock("about/title");
  const content = await getContentBlock("about/content");
  const image = await getContentBlock("about/image");
  const editable = (await getUserId(request)) !== null;

  return {
    title,
    content,
    image,
    editable,
  };
};

export default function AboutPage() {
  const { title, content, image, editable } = useLoaderData<LoaderData>();

  return (
    <div className="main-layout-centered my-10">
      <article>
        <h1 className="text-5xl mb-3">
          <ContentBlock block={title} editable={editable} />
        </h1>

        <ContentBlock block={content} editable={editable} />

        <div className="max-w-3xl my-5">
          <ContentBlock block={image} editable={editable} />
        </div>
      </article>
    </div>
  );
}
